export default "__VITE_ASSET__BWv2anxR__"